
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorPistonClosed as ObiTwowayAcuatorPistonClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-piston-closed.js';
 
 
 

 
 export const ObiTwowayAcuatorPistonClosed = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-piston-closed',
   elementClass: ObiTwowayAcuatorPistonClosedElement,
   events: {
     
   }
  });
 
 